import TextField from "@mui/material/TextField";

const TextPropertyField = ({ initialValue, label, onChange, placeholder }) => (
  <TextField
    defaultValue={initialValue}
    fullWidth
    label={label}
    onChange={(e) => onChange?.(e.target.value)}
    placeholder={placeholder}
    size="small"
    variant="outlined"
  />
);

export default TextPropertyField;
